import * as z from "zod";

/**
 * Shared Zod schema for validating bank and fund manager names.
 *
 * Rules:
 * - Must not be empty or whitespace-only
 * - Must not exceed 100 characters
 * - May only contain alphanumeric characters, spaces, &, -, ., and '
 */
export const bankOrFundManagerNameSchema = z
  .string()
  .min(1, "Name is required")
  .max(100, "Name must be 100 characters or less")
  .regex(
    /^[a-zA-Z0-9 &\-.']+$/,
    "Name may only contain letters, numbers, spaces, and the characters & - . '",
  )
  .refine((val) => val.trim().length > 0, {
    message: "Name must not be empty or contain only whitespace",
  });
